import * as ActionTypes from './ActionTypes';

export const InitialKirk = {
  // user: '',
  date: '',
  place: '',
  person: '',
  subject: '',
  reason: '',
  how: '',
  data: '',
  work: false,
  news: false,
  buy: false,
  utilities: false,
  // symptoms: false,
  events: false,
  health: false,
  foods: false,
  invests: false,
};

export const Kirks = (
  state = {
    errMess: null,
    kirks: [],
  },
  action
) => {
  switch (action.type) {
    case ActionTypes.KIRKS_UPDATING:
      return {
        ...state,
        isUpdating: true,
        errMess: null,
      };

    case ActionTypes.ADD_KIRKS:
      return {
        ...state,
        isLoading: false,
        isUpdating: false,
        errMess: null,
        kirks: action.payload,
      };

    case ActionTypes.KIRKS_LOADING:
      return {
        ...state,
        isLoading: state.kirks.length === 0,
        isUpdating: false,
        errMess: null,
      };

    case ActionTypes.KIRKS_FAILED:
      return {
        ...state,
        isLoading: false,
        isUpdating: false,
        errMess: state.kirks.length === 0 ? action.payload : null,
      };

    case ActionTypes.ADD_KIRK:
      var kirk = action.payload;
      return {
        ...state,
        isLoading: false,
        isUpdating: false,
        kirks: state.kirks.concat(kirk),
      };

    case ActionTypes.EDITED_KIRK:
      // var kirk = action.payload;
      const index = state.kirks.findIndex((curr) => {
        return curr._id === action.payload._id;
      });
      state.kirks[index] = action.payload;
      return {
        ...state,
        isLoading: false,
        isUpdating: false,
        errMess: null,
        kirks: state.kirks,
      };

    default:
      return state;
  }
};
